import React from "react";
import { renderNode } from '../../renderer';

export function renderChildren(
    children: any[] = [],
    ctx?: any
) {
    return children.map(
        (child, index) => (
            <React.Fragment key={index}>
                {renderNode(child, index, ctx)}
            </React.Fragment>
        )
    );
}

export default renderChildren;
